import { render, staticRenderFns } from "./BillingUsageTotal.vue?vue&type=template&id=5615e92c&"
import script from "./BillingUsageTotal.vue?vue&type=script&lang=js&"
export * from "./BillingUsageTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5615e92c')) {
      api.createRecord('5615e92c', component.options)
    } else {
      api.reload('5615e92c', component.options)
    }
    module.hot.accept("./BillingUsageTotal.vue?vue&type=template&id=5615e92c&", function () {
      api.rerender('5615e92c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/billing/BillingUsageTotal.vue"
export default component.exports